import { translate, translateFormatter, type RichTextFormatter } from '@/core/localization/translate';
export const {
  subtitle,
  title
} = translate({
  "subtitle": "Our experts' choice by price and design",
  "title": "Our recommended products"
});
export const team = translateFormatter<{
  logo: RichTextFormatter;
}>([{
  "type": 8,
  "value": "logo",
  "children": []
}, {
  "type": 0,
  "value": " team"
}], undefined, undefined, "en");